// extracted by mini-css-extract-plugin
var _1 = "NotificationCommentPreview-module__animateUploadProgressBarWidth--d7Lq4";
var _2 = "NotificationCommentPreview-module__animatedBackground--rJQg9";
var _3 = "NotificationCommentPreview-module__container--sCnNb";
var _4 = "NotificationCommentPreview-module__context--xed1R";
var _5 = "NotificationCommentPreview-module__preview--TDSCP";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "context", _5 as "preview" }
